<template>
  <!--  -->
    <span class="page-button">
      <el-button :id="id" @click.stop="clickEvent" :loading="loading" :class="`pb-${type}`" :plain="plain" :disabled="disabled || accessDisabled" :type="elType" :size="size" :icon="icon"><slot/></el-button>
    </span>
</template>

<script>
import {ElMessageBox} from 'element-plus';
import {getCurrentInstance} from "vue";
import ButtonRight from "@/components/h5/button/ButtonRight";
import {useRoute, useRouter} from "vue-router";

export default({
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  props: {
    loading: {default: false},
    disabled: {default: false},
    // 可用参数 按钮的权限类型，根据菜单进行授权
    type: { type: String, default: ""},
    plain: {default: false},
    // 填写多个时，权重越低的权限会覆盖权重高的权限
    // 按钮权限 具有某一种权限才能够访问    权重：0
    hasPerm: {default: ""},
    // 某权限组权限，具有任意某组权限才能够访问   权重：1
    hasAnyPerms: {default: ""},
    // 某权限组权限，具有所有某组权限才能够访问（指同一菜单下的多权限校验，如果是跨菜单。则直接为false）  权重：2
    hasAllPerms: {default: ""},
    // 与el-button的type一致
    elType: {default: ""},
    size: {default: ""},
    // 信息数据，用于操作前的提醒, click是确认操作，cancel事件是取消操作
    message: {default: ""},
    icon: {default: ""}
  },
  name: "PageButton",
  components: {
  },
  data() {
    return {
      // 是否被授权了这个功能
      accessDisabled: false,
      accessModules: [],
      id: "",
    };
  },
  created() {
    this.id = "page_button" + (Math.random()*9999).toFixed(0);
    const ins = getCurrentInstance();
    if (!this.hasPerm && !this.hasAnyPerms && !this.hasAllPerms) {
      return;
    }
    // 校验权限
    ButtonRight.buttonHasRight(this.hasPerm, this.hasAnyPerms, this.hasAllPerms, this).then(canAccess => {
      // 这个按钮，是否有授权
      this.accessDisabled = !canAccess;
      this.register2Parent(ins);
    })
  },
  methods: {
    // 注册到父级组件
    register2Parent(ins) {
      // 获取slot中的文本
      if (ins && ins.slots.default) {
        const slotContent = ins.slots.default();
        // 有对应的对象
        if (slotContent.length === 1 && typeof slotContent[0].children === "string") {
          // 如果有上级，进行group注册
          if (this.$parent.addButton) {
            this.$parent.addButton({id: this.id, label: slotContent[0].children, button: this, elType: this.elType, disabled: this.disabled || this.accessDisabled});
          }
        }
      }
    },
    clickEvent() {
      // 禁用状态
      if (this.disabled || this.accessDisabled) {
        this.$message.warning("您没有权限进行此操作，或此数据暂时不支持这个操作，请联系管理人员")
        return false;
      }
      // 什么也不做
      if (this.message) {
        ElMessageBox.confirm(this.message, "提示", {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.$emit("click");
        }).catch(() => {
          this.$emit("cancel")
        })
      } else {
        this.$emit("click");
      }
    },
  }
});
</script>

<style lang="scss" scoped>
.page-button{
  margin-right: 10px;
  vertical-align: top;
  display: inline-block;
}
.page-button:last-child{
  margin-right: 0;
}
:deep(.el-button){
  padding: 6px 10px;
  font-size: 12px;
}
//:deep(.el-button--write) {
//
//}
//:deep(.el-button--write.el-button:hover){
//  color: #FFF;
//  background: #95d475;
//}

</style>